import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Output,
} from '@angular/core';
import { map, take } from 'rxjs';

import { CurrencyService, TranslatePipe } from '@speedy/core';
import { NgClass, AsyncPipe, UpperCasePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIconButton } from '@angular/material/button';

@Component({
  selector: 'app-currency-dropdown',
  templateUrl: './currency-dropdown.component.html',
  styleUrls: ['./currency-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatIconButton,
    MatMenuTrigger,
    MatIcon,
    MatMenu,
    MatMenuItem,
    NgClass,
    AsyncPipe,
    UpperCasePipe,
    TranslatePipe,
  ],
})
export class CurrencyDropdownComponent {
  private readonly currencyService = inject(CurrencyService);

  @Output() childEvent = new EventEmitter();

  currentCurrency$ = this.currencyService.getCurrentCurrency();
  currencies$ = this.currencyService.currenciesData$.pipe(
    map((data) => data?.available_currency_codes),
  );

  setCurrency(currency: string, currentCurrency: string) {
    if (currentCurrency !== currency) {
      this.childEvent.emit();

      this.currencyService
        .setCurrency(currency)
        .pipe(take(1))
        .subscribe(() => {
          this.currencyService.currentCurrency$.next(currency);
        });
    }
  }
}
